import { createContext, useContext, useState, useEffect } from 'react';

export const CLASS_ROUTE_PREFIXES = [
  '/class/', '/students/', '/attendance/', '/behaviour/', '/out-of-class/',
  '/lessons/', '/ai-summary/', '/teams/', '/whiteboard/', '/seating-plan/',
  '/student-picker/', '/timer', '/calculator', '/noise-meter', '/live-mode'
];

const ThemeContext = createContext();

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
  const [preference, setPreference] = useState(() => {
    return localStorage.getItem('reliefify-theme') || 'system';
  });

  const [systemDark, setSystemDark] = useState(() => {
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
  });

  useEffect(() => {
    const mq = window.matchMedia('(prefers-color-scheme: dark)');
    const handler = (e) => setSystemDark(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  useEffect(() => {
    localStorage.setItem('reliefify-theme', preference);
  }, [preference]);

  const isDark = preference === 'dark' || (preference === 'system' && systemDark);

  const cycleTheme = () => {
    setPreference(prev => {
      if (prev === 'system') return 'dark';
      if (prev === 'dark') return 'light';
      return 'system';
    });
  };

  return (
    <ThemeContext.Provider value={{ preference, setPreference, isDark, cycleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
